import { Button, Carousel, CarouselItem, Form, Modal } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { gameList } from '../../../utils/games';
import SinglesSetup from './displays/SinglesSetup';
import { useEffect, useState } from 'react';
import DoublesSetup from './displays/DoublesSetup';
import { convertPlayerNamesToMatchViewModel } from '../../../logic/setup/setup';
import { saveMatchData } from '../../../backend/entryPoints/saveMatchDataToServer';

function SetupGameModal(props: { show: boolean; onClose: () => void }) {
    const { t } = useTranslation();
    const [currentPage, setCurrentPage] = useState(0);
    const maxPages = 10;
    const [homeTeam, setHomeTeam] = useState('');
    const [guestTeam, setGuestTeam] = useState('');

    useEffect(() => {
        if (props.show) {
            setCurrentPage(0);
        }
    }, [props.show]);

    const nextPage = () => {
        setCurrentPage((prevPage) => Math.min(prevPage + 1, maxPages - 1));
    };

    const previousPage = () => {
        setCurrentPage((prevPage) => Math.max(prevPage - 1, 0));
    };

    const confirmSetup = () => {
        const matchViewModels = convertPlayerNamesToMatchViewModel();
        matchViewModels.map((mvm) => ({
            ...mvm,
            home_team: homeTeam,
            guest_team: guestTeam,
        }));
        matchViewModels.forEach((mvm) => saveMatchData(mvm));
        props.onClose();
    };

    return (
        <Modal show={props.show} centered={true} size={'lg'} onHide={props.onClose}>
            <Modal.Header closeButton>
                <Modal.Title>{t('setup.title')}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Carousel controls={false} indicators={false} activeIndex={currentPage}>
                    <CarouselItem>
                        <p style={{ fontSize: '20px' }}>{t('setup.info.teams')}</p>
                        <p style={{ fontSize: '20px' }}>{t('setup.info.players')}</p>
                    </CarouselItem>
                    <CarouselItem>
                        <p style={{ fontSize: '20px' }}>{t('general.home_team')}</p>
                        <Form.Control
                            type="text"
                            placeholder={t('general.home_team')}
                            style={{ marginTop: '12px', fontSize: '24px' }}
                            value={homeTeam}
                            onChange={(val) => setHomeTeam(val.target.value)}
                        />
                        <hr />
                        <p style={{ fontSize: '20px' }}>{t('general.guest_team')}</p>
                        <Form.Control
                            type="text"
                            placeholder={t('general.guest_team')}
                            style={{ marginTop: '12px', fontSize: '24px' }}
                            value={guestTeam}
                            onChange={(val) => setGuestTeam(val.target.value)}
                        />
                    </CarouselItem>
                    {gameList.map((game) => (
                        <CarouselItem key={`carousel-item-${game}`} style={{ padding: '16px' }}>
                            <h5>{t('setup.info.players_explicit', { game })}</h5>
                            <hr />
                            {game.includes('D') ? <DoublesSetup game={game} /> : <SinglesSetup game={game} />}
                        </CarouselItem>
                    ))}
                </Carousel>
            </Modal.Body>
            <Modal.Footer>
                {currentPage !== 0 ? (
                    <Button onClick={previousPage} style={{ fontSize: '20px' }}>
                        {t('general.previous')}
                    </Button>
                ) : null}
                {currentPage !== maxPages - 1 ? (
                    <Button onClick={nextPage} style={{ fontSize: '20px' }}>
                        {t('general.next')}
                    </Button>
                ) : (
                    <Button onClick={confirmSetup} style={{ fontSize: '20px' }}>
                        {t('general.confirm')}
                    </Button>
                )}
            </Modal.Footer>
        </Modal>
    );
}

export default SetupGameModal;
